import {
  ADDED_CONSENT,
  LOADED_CONSENTS,
  LOADED_PENDING_CONSENTS,
  PartnerActions,
  PartnerMap,
  PartnerState,
  REMOVED_CONSENT,
  REMOVED_PENDING_CONSENT,
} from './types';

import { CONFIG_UPDATE, ConfigActions } from '../config/types';

const initialState: PartnerState = {
  connected: [],
  partners: {},
  pendingConnections: [],
  consentsLoaded: false,
  pendingConsentsLoaded: false,
};

export const partnerReducer = (
  state = initialState,
  action: ConfigActions | PartnerActions
): PartnerState => {
  switch (action.type) {
    case LOADED_CONSENTS:
      return {
        ...state,
        connected: action.consents,
        consentsLoaded: true,
      };

    case LOADED_PENDING_CONSENTS:
      return {
        ...state,
        pendingConnections: action.pendingConsents,
        pendingConsentsLoaded: true,
      };

    case CONFIG_UPDATE:
      const { api, commercialapi, fhir, inbound, insulet, redox } = action.config.partners;
      const partners = [
        ...((api && Object.values(api)) || []),
        ...((commercialapi && Object.values(commercialapi)) || []),
        ...((fhir && Object.values(fhir)) || []),
        ...((inbound && Object.values(inbound)) || []),
        ...((insulet && Object.values(insulet)) || []),
        ...((redox && Object.values(redox)) || []),
      ].reduce<PartnerMap>((pv, cv) => ((pv[cv.id] = cv), pv), {});

      return {
        ...state,
        partners,
      };

    case REMOVED_CONSENT:
      return {
        ...state,
        connected: state.connected.filter((c) => c.clientId !== action.partnerId),
      };

    case REMOVED_PENDING_CONSENT:
      return {
        ...state,
        pendingConnections: state.pendingConnections.filter((c) => c.clientId !== action.partnerId),
      };

    case ADDED_CONSENT:
      const consent = action.consent;

      return {
        ...state,
        connected: [...state.connected, consent],
      };

    default:
      return state;
  }
};
